import { useState, useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { authContext } from "./contexts/AuthProvider";
import Loader from "./layout/Loader";
import Header from "./layout/Header";
import Sidebar from "./layout/Sidebar";
import Footer from "./layout/Footer";
import ScrollToTop from "./layout/ScrollToTop";
import Map from "./layout/map/Map";
import ManageOrders from "./order/ManageOrders";
import NotificationBar from "./layout/NotificationBar";
import LoadScript from "./utils/LoadScript";
import { loaderContext } from "./contexts/LoaderProvider";
import { fetchNotifications } from "./services/notificationService";

const Dashboard = () => {
  const [notifications, setNotifications] = useState([]);
  const [hideMap, setHideMap] = useState(false);
  const { isLoading, setIsLoading } = useContext(loaderContext);
  const [isAuth] = useContext(authContext);
  const navigate = useNavigate();

  const getNotifications = async () => {
    const response = await fetchNotifications();
    if (response?.data?.code === 1) {
      setNotifications(response?.data?.data);
    }
  };

  useEffect(() => {
    if (isAuth === true) {
      setIsLoading(false);
    }
    if (isAuth === false) {
      navigate("/");
    }
  }, [isAuth, navigate, setIsLoading]);

  useEffect(() => {
    getNotifications();
  }, []);

  return isLoading === true ? (
    <Loader />
  ) : (
    <>
      {/* page */}
      <div className="page">
        <Header />
        <Sidebar />
        <div className="main-content app-content">
          <div className="container-fluid py-3">
            <div className="row">
              {Array.isArray(notifications) && notifications?.length > 0 && (
                <div className="col-md-12">
                  <div className="card py-0 mb-2">
                    <div className="card-body py-1">
                      <NotificationBar notifications={notifications} />
                    </div>
                  </div>
                </div>
              )}
              {hideMap === false && (
                <div className="col-md-12">
                  <div className="card mb-2">
                    <div className="card-body">
                      <Map />
                    </div>
                  </div>
                </div>
              )}
            </div>
            {/* Start::app-content */}
            <ManageOrders hideMap={hideMap} setHideMap={setHideMap} />
            {/* End::app-content */}
          </div>
        </div>
        <Footer />
      </div>
      {/* End Page*/}
      <ScrollToTop />
      <LoadScript />
    </>
  );
};

export default Dashboard;
